var $deb83970956f6d5b$exports = {};
$deb83970956f6d5b$exports = {
    "removeButtonLabel": `Fjern`,
    "removeDescription": `Tryk p\xe5 Slet for at fjerne tag.`
};


export {$deb83970956f6d5b$exports as default};
//# sourceMappingURL=da-DK.module.js.map
